import angular from 'angular';

module.exports = angular.module('common.filters.display-owner-name', [])
.filter('displayOwnerName', function() {
  return function(value) {
    if (!value) return;
    return value.replace(/,/g, ', ').toLowerCase();
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/display-owner-name.js
 **/